<div class="bg-white border rounded p-3 mb-3">
  <h6 class="mb-2">Person Search</h6>
  <div class="row g-2 align-items-end mb-2">
    <div class="col-auto">
      <label class="form-label" for="searchFirst">First Name</label>
      <input
        id="searchFirst"
        type="text"
        class="form-control"
        placeholder="First name"
        [(ngModel)]="firstName"
        name="searchFirst"
      />
    </div>
    <div class="col-auto">
      <label class="form-label" for="searchLast">Last Name</label>
      <input
        id="searchLast"
        type="text"
        class="form-control"
        placeholder="Last name"
        [(ngModel)]="lastName"
        name="searchLast"
      />
    </div>
    <div class="col-auto">
      <label class="form-label" for="searchEin">EIN</label>
      <input
        id="searchEin"
        type="text"
        class="form-control"
        placeholder="EIN"
        [(ngModel)]="ein"
        name="searchEin"
        numericOnly
      />
    </div>
    <div class="col-2">
      <label class="form-label" for="leaSiteCodeId"
        >Location
        <i class="info-icon ms-2" certTooltip="Do not select a Location to search the entire district."></i>
      </label>
      <ng-select
        id="leaSiteCodeId"
        name="leaSiteCodeId"
        [items]="leaSiteCodes"
        bindLabel="description"
        bindValue="leaSiteCodeId"
        [(ngModel)]="leaSiteCodeId"
        placeholder="Select Location"
      >
      </ng-select>
    </div>
    <div class="col-auto">
      <button class="btn btn-outline-primary" (click)="onSearch()">Search</button>
    </div>
    <div class="col-auto">
      <button class="btn btn-outline-danger" (click)="onClear()">Clear</button>
    </div>
  </div>

  <div class="row g-2 align-items-end mb-2 pt-2">
    <div class="col">
      <label class="form-label" for="bulkEin">
        Bulk EIN Lookup (comma-separated)
        <i
          class="info-icon ms-2"
          certTooltip="Use the Format button to the right to convert a list of EINs to a valid format"
        ></i>
      </label>
      <input
        id="bulkEin"
        type="text"
        class="form-control"
        placeholder="1000001, 1000002, 1000003"
        [(ngModel)]="bulkEinInput"
        name="bulkEin"
      />
    </div>
    <div class="col-auto">
      <button
        type="button"
        class="btn btn-outline-secondary"
        title="Open formatter to convert multi-line list to comma-separated"
        (click)="openBulkFormatterModal()"
      >
        Format
      </button>
    </div>
    <div class="col-auto">
      <button class="btn btn-outline-primary" (click)="onBulkSearch()">Search</button>
    </div>
    <div class="col-auto">
      <button class="btn btn-outline-danger" (click)="onBulkClear()">Clear</button>
    </div>
  </div>

  @if (searching) {
    <p class="text-center text-muted mt-4 mb-0">Searching...</p>
  } @else if (searchPerformed && results.length === 0 && unmatchedEins.length === 0) {
    <p class="text-danger mt-4 mb-0">No matches were found.</p>
  }

  @if (results.length > 0) {
    <cert-pd-advanced-person-search-results-grid
      [results]="results"
      [leaSiteCodes]="leaSiteCodes"
      [selectedPersonIds]="selectedPersonIds"
      (select)="relaySelectEvent($event)"
      (deselect)="relayDeselectEvent($event)"
    />
  }

  @if (unmatchedEins.length > 0) {
    <div class="alert alert-warning mt-3 mb-0">
      <strong>No matches found for:</strong> {{ unmatchedEins.join(', ') }}
    </div>
  }
</div>
